
      if (import.meta.env.VITE_APP_TITLE) {
        document.title = import.meta.env.VITE_APP_TITLE;
      }
    